var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"logoscorp",attrs:{"id":"logoscorp"}},[_c('AppDrawer'),_c('AppToolBar'),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"container content-box"})],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }